export default __webpack_public_path__ + "static/media/peripheral4.ffd9ca5b.jpg";